import React, { useContext } from "react";
import { UserContext } from "context/UserContext";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import useApiConfig from "hooks/useApiConfig";
import Login from "app/Login/Login";
import PageNotFound from "components/PageNotFound/PageNotFound";
import LoadingPage from "components/Loading/LoadingPage/LoadingPage"
import { DASHBOARD_PATH, LOGIN_PATH } from "global/constants";
import { ENGLISH, FixedLanguage } from "context/LanguageContext";
import 'global/styles/App.scss';

const DashboardLayout = React.lazy(() => import("app/Dashboard/DashboardLayout"))


const App = () => {

  const [token, setToken, id, email, role] = useContext(UserContext);
  const { message, configReady } = useApiConfig();

  if (token === undefined || !configReady) {
    return <LoadingPage />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path={LOGIN_PATH}
          element={token ? <Navigate to={DASHBOARD_PATH} replace /> : (
            <FixedLanguage language={ENGLISH}>
              <Login message={message}/>
            </FixedLanguage>
          )}
        />
        <Route
          path={`${DASHBOARD_PATH}/*`}
          element={
            token ? (
              <React.Suspense fallback={<LoadingPage/>}>
                <DashboardLayout
                  setToken={setToken} id={id} email={email} role={role} message={message}
                />
              </React.Suspense>
            ) : (
              <Navigate to={LOGIN_PATH} replace />
            )
          }
        />
        <Route path="/" element={<Navigate to={token ? DASHBOARD_PATH : LOGIN_PATH} replace />}/>
        <Route path="*" element={<PageNotFound/>}/>
      </Routes>
    </BrowserRouter>
  );
  
};

export default App;
